/**
 * Utils 公共辅助类
 */
// 引入 axios

import Axios from 'axios'
import QS from 'qs'
import { Toast, Indicator } from 'mint-ui'

let Utils = {
  // envUrl: 'dev',
  envUrl: 'pro',
  // 图片资源路径
  ResourceUrl: 'http://zjcdn.zxzx119.com/',
  loginState: function () {
    return localStorage.getItem('isLogin')
  },
  POSTHeader: function (url, header, param, success) {
    Utils.POSTHeaderQS(url, header, false, param, success)
  },
  POSTQS: function (url, qs, param, success) {
    Utils.POSTHeaderQS(url, null, qs, param, success)
  },
  POSTHeaderQS: function (url, header, qs, param, success) {
    Indicator.open({
      spinnerType: 'fading-circle'
    })
    var headers = {}
    if (header !== null) {
      headers = header
    }
    headers['orgin'] = 'H5'
    var reqParam = param
    if (qs === true) {
      reqParam = QS.stringify(param)
    }
    Axios({
      method: 'post',
      url: url,
      data: reqParam,
      headers: headers
    })
      .then(function (response) {
        // 关闭动画
        Indicator.close()

        console.log(response)
        let data = response.data
        if (data === null) {
          // 空返回
          return
        }
        if (data.code === 0) {
          if (data.message === '未登录') {
            // 清空登录数据
            localStorage.setItem('isLogin', 0)
            // localStorage.setItem('userinfo', null)
          }
          success(data)
        } else {
          success(data)
          Toast(data.message)
        }
      })
      .catch(function () {
        // 关闭动画
        Indicator.close()
        // Indicator.close()
        // console.log(error)
      })
    // 统计
    Utils.eventClickRecord(url)
  },
  POST: function (url, param, success) {
    Indicator.open({
      spinnerType: 'fading-circle'
    })
    var headers = {}
    // headers['orgin'] = 'H5'
    Axios({
      method: 'post',
      url: url,
      data: QS.stringify(param),
      headers: headers
    })
      .then(function (response) {
        // 关闭动画
        Indicator.close()

        console.log(response)
        let data = response.data
        if (data === null) {
          // 空返回
          return
        }
        if (data.code === 0) {
          if (data.message === '未登录') {
            // 清空登录数据
            localStorage.setItem('isLogin', 0)
            // localStorage.setItem('userinfo', null)
          }
          success(data)
        } else {
          Toast(data.message)
        }
      })
      .catch(function () {
        // 关闭动画
        Indicator.close()
        // console.log(error)
      })
    // 统计
    Utils.eventClickRecord(url)
  },
  post: function (url, param, success) {
    Indicator.open({
      spinnerType: 'fading-circle'
    })
    Axios({
      method: 'post',
      url: url,
      data: param,
      headers: {
        'Content-Type': 'application/json',
        isApp: localStorage.getItem('isApp')
      }
    })
      .then(function (response) {
        // 关闭动画
        Indicator.close()

        console.log(response)
        let data = response.data
        if (data === null) {
          // 空返回
          return
        }
        if (data.code === 0) {
          if (data.message === '未登录') {
            // 清空登录数据
            localStorage.setItem('isLogin', 0)
            // localStorage.setItem('userinfo', null)
          }
          success(data)
        } else {
          Toast(data.message)
          success(data)
          // if (url.indexOf('shoppingCart/update') >= 0) {
          //   success(data)
          // }
        }
      })
      .catch(function () {
        // 关闭动画
        Indicator.close()
        // console.log(error)
      })
    // 统计
    Utils.eventClickRecord(url)
  },
  GET: function (url, success) {
    Indicator.open({
      spinnerType: 'fading-circle'
    })
    var headers = {}

    headers['orgin'] = 'H5'
    Axios({
      method: 'get',
      url: url,
      withCredentials: true,
      // url: 'http://192.168.110.245:8070' + url
      headers: headers
    })
      .then(function (response) {
        // 关闭动画
        Indicator.close()
        // Toast(url)
        // console.log(response)
        let data = response.data
        if (data === null) {
          // 空返回
          return
        }
        if (data.code === 0) {
          if (data.message === '未登录') {
            // 清空登录数据
            localStorage.setItem('isLogin', 0)
            // localStorage.setItem('userinfo', null)
          }
          success(data)
        } else {
          success(data)
          if (typeof data.message !== 'undefined') {
            Toast(data.message)
          }
        }
      })
      .catch(function () {
        // 关闭动画
        Indicator.close()
        // fail(error)
      })
    // 统计
    Utils.eventClickRecord(url)
  },
  get: function (url, param, success) {
    Indicator.open({
      spinnerType: 'fading-circle'
    })
    let headers = {}
    headers['orgin'] = 'H5'
    Axios({
      method: 'get',
      url: url,
      params: param,
      headers: headers
    }).then(res => {
      Indicator.close()
      let data = res.data
      if (data === null) {
        // 空返回
        return
      }
      if (data.code === 0) {
        if (data.message === '未登录') {
          localStorage.setItem('isLogin', 0)
        }
        success(data)
      } else if (data.code === 1) {
        success(data)
      }
    })
  },
  GETHeader: function (url, header, success) {
    Indicator.open({
      spinnerType: 'fading-circle'
    })
    console.log(url)
    var headers = {}
    if (header !== null) {
      headers = header
    }
    headers['orgin'] = 'H5'
    Axios({
      method: 'get',
      url: url,
      headers: headers
    })
      .then(function (response) {
        // 关闭动画
        Indicator.close()

        console.log(response)
        let data = response.data
        if (data === null) {
          // 空返回
          return
        }
        if (data.code === 0) {
          if (data.message === '未登录') {
            // 清空登录数据
            localStorage.setItem('isLogin', 0)
            // localStorage.setItem('userinfo', null)
          }
          success(data)
        } else {
          Toast(data.message)
        }
      })
      .catch(function (response) {
        // 关闭动画
        Indicator.close()
        // fail(response)
      })
    // 统计
    Utils.eventClickRecord(url)
  },
  uploadImage: function (e, success) {
    // 图片上传
    Indicator.open({
      text: '图片上传中...',
      spinnerType: 'triple-bounce'
    })
    var file = e.target.files[0]
    let param = new FormData()
    param.append('imgFile', file)
    Axios({
      method: 'post',
      url: 'http://www.zxzx119.com/account/kindeditor/upload_json_qiniu',
      // url: '/account' + '/kindeditor/upload_json_qiniu',
      headers: {
        'content-type': 'multipart/form-data',
        orgin: 'H5'
      },
      data: param
    })
      .then(function (response) {
        console.log(response)
        Indicator.close()
        let data = response.data.data
        success(data['fileId'])
      })
      .catch(function () {
        // 关闭动画
        Indicator.close()
      })
  },
  uploadReportImage: function (e, success) {
    // 图片上传
    Indicator.open({
      text: '图片上传中...',
      spinnerType: 'triple-bounce'
    })
    console.log(e)
    var file = e
    let param = new FormData()
    param.append('imgFile', file)
    Axios({
      method: 'post',
      url: 'http://www.zxzx119.com/account/kindeditor/upload_json_qiniu',
      // url: '/account' + '/kindeditor/upload_json_qiniu',
      headers: {
        'content-type': 'multipart/form-data'
      },
      data: param
    })
      .then(function (response) {
        console.log(response)
        Indicator.close()
        let data = response.data.data
        success(data['fileId'])
      })
      .catch(function () {
        // 关闭动画
        Indicator.close()
      })
  },
  isUserLogin: function (login) {
    Axios({
      method: 'get',
      url: '/account' + '/account/islogin',
      headers: {
        orgin: 'H5'
      }
    })
      .then(function (response) {
        let data = response.data
        if (data.code === 0) {
          if (data.message === '未登录') {
            // 清空登录数据
            localStorage.setItem('isLogin', 0)
            // localStorage.setItem('userinfo', null)
            login(0)
          } else {
            localStorage.setItem('isLogin', 1)
            login(1)
          }
        }
      })
      .catch(function (response) {
        // 关闭动画
        Indicator.close()
      })
  },
  isIphoneX: function () {
    // 判断iphone X
    var u = navigator.userAgent
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    if (isIOS) {
      if (
        (screen.height === 812 && screen.width === 375) ||
        (screen.height === 896 && screen.width === 414) ||
        (screen.height === 844 && screen.width === 390) ||
        (screen.height === 926 && screen.width === 428) ||
        (screen.height === 708 && screen.width === 306)
      ) {
        // 是iphoneX
        return true
      } else {
        return false
      }
    }
    return false
  },
  isIphone12or13: function () {
    // 判断iphone 12
    var u = navigator.userAgent
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    if (isIOS) {
      if (
        (screen.height === 844 && screen.width === 390) ||
        (screen.height === 926 && screen.width === 428) ||
        (screen.height === 708 && screen.width === 306)
      ) {
        // 是iphoneX
        return true
      } else {
        return false
      }
    }
    return false
  },
  isWX: function () {
    // 判断是 微信浏览器
    let ua = navigator.userAgent.toLowerCase()
    return !!/micromessenger/.test(ua)
  },
  isIphone: function () {
    // 判断机型
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    if (isiOS === true) {
      return true
    }
    if (isAndroid === true) {
      return false
    }
  },

  eventClickRecord: function (url) {
    // 接口 点击事件 统计
    if (url.indexOf('riskeval/upload_file_qiniu') >= 0) {
      Utils.listenEvent(8, '', window.location.href, '')
    }
    if (url.indexOf('riskeval/sendCode') >= 0) {
      Utils.listenEvent(9, '', window.location.href, '')
    }
    if (url.indexOf('riskeval/getUserDataByPhone') >= 0) {
      Utils.listenEvent(10, '', window.location.href, '')
    }
    // if (url.indexOf('riskeval/saveUserData') >= 0) { // 开始评测 ======
    //   Utils.listenEvent(12, '', window.location.href, '')
    // }
    if (url.indexOf('riskeval/commitSiteCategory') >= 0) {
      Utils.listenEvent(14, '', window.location.href, '')
    }
    if (url.indexOf('zxOrder/saveRiskevalOrderByItem') >= 0) {
      Utils.listenEvent(15, '', window.location.href, '')
    }
    if (url.indexOf('shoppingCart/releaseWantBuy') >= 0) {
      Utils.listenEvent(18, '', window.location.href, '')
    }
    if (url.indexOf('site/save') >= 0) {
      Utils.listenEvent(19, '', window.location.href, '')
    }
  },
  listenEvent: function (type, id, url, title) {
    // type 1 2 3 4
    var typeStr = ''
    switch (type) {
      case 1:
        typeStr = 'H5_VIEW_WIKI_DETAIL'
        break
      case 2:
        typeStr = 'H5_VIEW_WIKI_Guide'
        break
      case 3:
        typeStr = 'H5_CLICK_WIKI_DETAIL'
        break
      case 4:
        typeStr = 'H5_CLICK_WIKI_Guide'
        break
      case 5:
        typeStr = 'H5_VIEW_RISKEVAL_TG'
        break
      case 6:
        typeStr = 'H5_CLICK_RISKEVAL_TG_BTN'
        break
      case 7:
        typeStr = 'H5_VIEW_RISKEVAL_COMPANY'
        break
      case 8:
        typeStr = 'H5_CLICK_RISKEVAL_COMPANY_UPLOAD'
        break
      case 9:
        typeStr = 'H5_CLICK_RISKEVAL_COMPANY_CODE'
        break
      case 10:
        typeStr = 'H5_CLICK_RISKEVAL_COMPANY_NEXT'
        break
      case 11:
        typeStr = 'H5_VIEW_RISKEVAL_USER'
        break
      case 12:
        typeStr = 'H5_CLICK_RISKEVAL_USER_START'
        break
      case 13:
        typeStr = 'H5_VIEW_RISKEVAL_SITE'
        break
      case 14:
        typeStr = 'H5_CLICK_RISKEVAL_SITE_NEXT'
        break
      case 15:
        typeStr = 'H5_CLICK_RISKEVAL_RESULT_PAY'
        break
      case 16:
        typeStr = 'H5_CLICK_RISKEVAL_RESULT_REPORT'
        break
      case 17:
        typeStr = 'H5_CLICK_RISKEVAL_RESULT_PACK'
        break
      case 18:
        typeStr = 'H5_CLICK_RISKEVAL_ORDER_PURCHASE'
        break
      case 19:
        typeStr = 'H5_CLICK_RISKEVAL_ORDER_GOODS'
        break
      default:
        break
    }
    var platform = 'h5'
    if (Utils.isIphone()) {
      platform = 'h5-iOS'
    } else {
      platform = 'h5-android'
    }
    let userinfoStr = localStorage.getItem('userinfo')
    var userID = 0
    if (
      userinfoStr !== null &&
      userinfoStr !== '' &&
      userinfoStr !== undefined
    ) {
      let userinfo = QS.parse(userinfoStr)
      userID = userinfo.tails.userinfo[0].id
    }
    var param = {
      code: typeStr, // 访问 标识码
      platform: platform, // 平台
      url: url, // 访问url 地址
      userId: userID, // 用户id
      arg1: id, // 访问自增长Id
      arg2: title,
      arg3: '',
      source: Utils.myBrowser() // 来源
    }

    Axios({
      method: 'post',
      // url:"http://192.168.110.234:8050/listen/submit",
      url: '/company' + '/listen/submit',
      data: param,
      headers: {
        orgin: 'H5'
      }
    })
      .then(function (response) {})
      .catch(function (response) {})
  },
  isPhone: function (phone) {
    var regPhone = /^1[3456789]\d{9}$/
    // var regPhone = /^(?:\+?86)?1(?:3\d{3}|5[^4\D]\d{2}|8\d{3}|7(?:[35678]\d{2}|4(?:0\d|1[0-2]|9\d))|9[189]\d{2}|66\d{2})\d{6}$/
    if (!regPhone.test(phone)) {
      return false
    }
    return true
  },
  isEmail: function (email) {
    if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(email)) {
      return false
    } else {
      return true
    }
  },
  isCard: function (card) {
    var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    if (!reg.test(card)) {
      return false
    }
    return true
  },
  myBrowser: function () {
    var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
    var isOpera = userAgent.indexOf('Opera') > -1 // 判断是否Opera浏览器
    var isIE =
      userAgent.indexOf('compatible') > -1 &&
      userAgent.indexOf('MSIE') > -1 &&
      !isOpera // 判断是否IE浏览器
    var isEdge = userAgent.indexOf('Edge') > -1 // 判断是否IE的Edge浏览器
    var isFirefox = userAgent.indexOf('Firefox') > -1 // 判断是否Firefox浏览器
    var isUC = userAgent.indexOf('UCBrowser') > -1 // 判断是否UC浏览器
    var isBaidu = userAgent.indexOf('BIDUBrowser') > -1 // 判断是否百度浏览器
    var isSafari =
      userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1 // 判断是否Safari浏览器
    var isChrome =
      userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1 // 判断Chrome浏览器
    if (isIE) {
      var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
      reIE.test(userAgent)
      var fIEVersion = parseFloat(RegExp['$1'])
      if (fIEVersion === 7) {
        return 'IE7'
      } else if (fIEVersion === 8) {
        return 'IE8'
      } else if (fIEVersion === 9) {
        return 'IE9'
      } else if (fIEVersion === 10) {
        return 'IE10'
      } else if (fIEVersion === 11) {
        return 'IE11'
      } else {
        return 'IE'
      } // IE版本过低
      // return 'IE'
    }
    if (isOpera) {
      return 'Opera'
    }
    if (isUC) {
      return 'UC'
    }
    if (isBaidu) {
      return 'Baidu'
    }
    if (isEdge) {
      return 'Edge'
    }
    if (isFirefox) {
      return 'Firefox'
    }
    if (isSafari) {
      return 'Safari'
    }
    if (isChrome) {
      return 'Chrome'
    }
  },
  isIphoneOrPc: function () {
    var sUserAgent = navigator.userAgent.toLowerCase()
    var bIsIpad = sUserAgent.match(/ipad/i) == 'ipad'
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
    var bIsMidp = sUserAgent.match(/midp/i) == 'midp'
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
    var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb'
    var bIsAndroid = sUserAgent.match(/android/i) == 'android'
    var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce'
    var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile'
    if (
      bIsIpad ||
      bIsIphoneOs ||
      bIsMidp ||
      bIsUc7 ||
      bIsUc ||
      bIsAndroid ||
      bIsCE ||
      bIsWM
    ) {
      return 'phone'
    } else {
      return 'pc'
    }
  },
  isNumber: function (number) {
    // 判断是数字
    let regTest = /(^[0-9]*[1-9][0-9]*$)/
    if (!regTest.test(number)) {
      return false
    }
    return true
  },
  isImageFile: function (e) {
    // 判断是图片文件
    var file = e.target.files[0]
    if (file === undefined) {
      return
    }
    // 判断文件 类型
    var AllImgExt = '.jpg|.jpeg|.png|'
    var extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase() // （把路径中的所有字母全部转换为小写）
    if (AllImgExt.indexOf(extName + '|') === -1) {
      Toast('请选择图片上传！')
      return false
    }
    return true
  },
  formatMoney: function (money) {},
  keepPoint: function (x) {
    // 强制保留2位小数，不足补 0
    var f = parseFloat(x)
    if (isNaN(f)) {
      return ''
    }
    f = Math.round(x * 100) / 100
    var s = f.toString()
    var rs = s.indexOf('.')
    if (rs < 0) {
      rs = s.length
      s += '.'
    }
    while (s.length <= rs + 2) {
      s += '0'
    }
    return s
  },
  getParam: function (name) {
    // 获取参数
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.href.substr(1).match(reg)
    console.log(window.location)
    console.log(r)

    if (r != null) {
      return decodeURI(r[2])
    }
    return null
  },
  log: function (data) {
    console.log(data)
  },
  isNull: function (obj) {
    if (!obj) {
      return true
    }
    if (obj == null) {
      return true
    }
    if (obj === null) {
      return true
    }
    if (typeof obj === 'undefined') {
      return true
    }
    // if (typeof obj === 'null') { return true }
    if (obj.length === 0) {
      return true
    }
    if (obj.replace(/(^s*)|(s*$)/g, '').length === 0) {
      return true
    }
    if (obj.replace(' ', '').length === 0) {
      return true
    }
    // // eslint-disable-next-line no-undef
    // if ($.trim(obj) === '') { return true }
    return false
  },
  dealTime: function (time) {
    if (time === '') {
      return '暂无'
    } else {
      // if (time.length > 10) {
      let date = new Date(parseInt(time) * 1000)
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let minute = date.getMinutes()
      let second = date.getSeconds()
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
    }
  },
  downLoadfile (cdn, url) {
    // const a = document.createElement('a') // 创建a标签
    // a.setAttribute('download', '')// download属性
    // a.setAttribute('href', cdn + url)// href链接
    // a.click()
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.style.height = 0
    iframe.src = cdn + url
    console.log(iframe.src)
    document.body.appendChild(iframe)
    setTimeout(() => {
      iframe.remove()
    }, 60000)
  },
  num_format (number, decimals, dec_point, thousands_sep) {
    // number_format(1234567.089, 2, ".", ",");//1,234,567.08
    /*
     * 参数说明：
     * number：要格式化的数字
     * decimals：保留几位小数
     * dec_point：小数点符号
     * thousands_sep：千分位符号
     * */
    number = (number + '').replace(/[^0-9+-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
      sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
      dec = typeof dec_point === 'undefined' ? '.' : dec_point,
      s = ''
    function toFixedFix (n, prec) {
      var k = Math.pow(10, prec)
      return '' + Math.floor(n * k) / k
    }
    s = (prec ? toFixedFix(n, prec) : '' + Math.floor(n)).split('.')
    var re = /(-?\d+)(\d{3})/
    while (re.test(s[0])) {
      s[0] = s[0].replace(re, '$1' + sep + '$2')
    }

    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    return s.join(dec)
  }
}
export default Utils



// WEBPACK FOOTER //
// ./src/utils/utils.js